import React from 'react';
import sovereignty from '../../assets/pictures/projects/cognitive-sovereignty-card.webp';
import warfare from '../../assets/pictures/projects/cognitive-warfare-card.webp';

export interface ProjectsProps {}

interface DossierBoxProps {
    image: string;
    date: string;
    title: string;
    excerpt: string;
    link: string;
}

const DossierBox: React.FC<DossierBoxProps> = ({
    image,
    date,
    title,
    excerpt,
    link,
}) => {
    const handleClick = () => {
        window.open(link, '_blank');
    };

    return (
        <div
            onMouseDown={handleClick}
            className="big-button-container"
            style={styles.dossier}
        >
            <img src={image} style={styles.dossierImage} alt="" />
            <div style={styles.dossierText}>
                <h3>{date}</h3>
                <br />
                <h2>{title}</h2>
                <br />
                <p>{excerpt}</p>
            </div>
        </div>
    );
};

const Projects: React.FC<ProjectsProps> = (props) => {
    return (
        <div className="site-page-content">
            <h1>Dossiers</h1>
            <h3>Strategic Analysis</h3>
            <br />
            <p>
                Dispatches from the frontlines of the information war. Click a
                dossier to read the full declassified analysis on the main
                site.
            </p>
            <br />
            <div style={styles.dossiersContainer}>
                <DossierBox
                    image={sovereignty}
                    date="JAN 06, 2026"
                    title="Cognitive Sovereignty is Dead: Why the Reality Kill Switch is the Only Strategy Left"
                    excerpt="The belief that truth protects itself is the West's most dangerous illusion. While we build Maginot lines of fact-checkers, our adversaries rewrite the source code of our culture. This analysis exposes the mathematical impossibility of defensive information warfare — and argues that to survive the 21st century, we must stop debunking lies and start engineering reality."
                    link="https://cire-dye-ba.pages.dev/articles/cognitive-sovereignty"
                />
                <DossierBox
                    image={warfare}
                    date="DEC 29, 2025"
                    title="The Evolution of Cognitive Warfare"
                    excerpt="The Clausewitzian era is dead. We have moved from kinetic war to pure cognitive combat where the battlefield is the human mind. This analysis explores how modern adversaries hack the OODA loop at the orientation phase to neutralize entire nations without firing a single shot."
                    link="https://cire-dye-ba.pages.dev/articles/cognitive-warfare"
                />
            </div>
            <div className="text-block">
                <h3>Twitter Hall of Fame</h3>
                <br />
                <p>
                    In the realm of influence and narrative confrontation, wit
                    and refined command of punchlines are decisive. A curated
                    hall of the most esteemed accounts in these fields is
                    maintained on the{' '}
                    <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://cire-dye-ba.pages.dev/twitter-hof"
                    >
                        main site
                    </a>
                    .
                </p>
            </div>
        </div>
    );
};

const styles: StyleSheetCSS = {
    dossiersContainer: {
        flexDirection: 'column',
        width: '100%',
        display: 'flex',
        flex: 1,
    },
    dossier: {
        marginBottom: 24,
        cursor: 'pointer',
        width: '100%',
        boxSizing: 'border-box',
        padding: 16,
        flexDirection: 'column',
    },
    dossierImage: {
        width: '100%',
        height: 'auto',
    },
    dossierText: {
        flexDirection: 'column',
        marginTop: 16,
    },
};

export default Projects;
